/**
 * Mixpanel analytics for AskAstro marketing site
 * Events follow "[Verb] [noun]" naming convention to match the web app.
 *
 * Only activates on askastro.ai domains. Logs to console on other domains.
 */
import mixpanel from 'mixpanel-browser/src/loaders/loader-module-core';

var PIXEL_EVENTS = {
    'Schedule': 'Schedule',
    'Lead': 'Lead',
    'Contact': 'Contact',
    'SubmitApplication': 'SubmitApplication'
};

var MIXPANEL_EVENTS = {
    'Schedule': 'Click Schedule CTA',
    'Lead': 'Click Lead CTA',
    'Contact': 'Click Contact CTA',
    'SubmitApplication': 'Click Submit Application CTA'
};

function fireTrackingEvent(trackingEvent, properties) {
    if (!trackingEvent) return;

    var pixelEvent = PIXEL_EVENTS[trackingEvent];
    if (pixelEvent && typeof fbq !== 'undefined') {
        fbq('track', pixelEvent, properties);
    }

    var mixpanelEvent = MIXPANEL_EVENTS[trackingEvent];
    if (mixpanelEvent) {
        mixpanelTrack(mixpanelEvent, properties, true);
    }
}

var TOKEN = '36cbeb32a68fdfa12833fad111a75d9d';
var PROXY_HOST = 'https://mixp.askastro.ai';
var isActive = location.hostname.endsWith('askastro.ai');

function mixpanelTrack(event, properties, isPageChange) {
    if (isActive) {
        mixpanel.track(event, properties, isPageChange ? {transport: 'sendBeacon'} : {});
    } else {
        console.log('[MIXPANEL]', event, properties);
    }
}

function trackCTAClick(label, destination, location) {
    mixpanelTrack('Click CTA', {
        'CTA Label': label,
        'CTA Destination': destination,
        'CTA Location': location,
        'Page Path': window.location.pathname
    }, true);
}

function getButtonLocation(button) {
    if (button.closest('.site-header')) return 'header';
    if (button.closest('.site-footer')) return 'footer';
    if (button.closest('.above-fold-block')) return 'hero-above-fold';
    if (button.closest('[class*="HeroBlock"]')) return 'hero';
    if (button.closest('[class*="CardsBlock"]')) return 'cards';
    if (button.closest('[class*="CarouselBlock"]')) return 'carousel';
    return 'page-content';
}

function initEventListeners() {
    document.addEventListener('click', function (e) {
        var button = e.target.closest('a.btn, button.btn');
        if (!button) return;

        var label = button.textContent.trim();
        var destination = button.href || button.getAttribute('data-href') || '';
        var location = getButtonLocation(button);

        var trackingEvent = button.getAttribute('data-tracking-event');
        if (trackingEvent) {
            fireTrackingEvent(trackingEvent, {
                'CTA Label': label,
                'CTA Destination': destination,
                'CTA Location': location,
                'Page Path': window.location.pathname,
                content_name: label,
                content_category: location
            });
        } else {
            trackCTAClick(label, destination, location);
        }
    });

    document.addEventListener('click', function (e) {
        var navLink = e.target.closest('.site-nav__link');
        if (!navLink) return;

        mixpanelTrack('Click navigation', {
            'Link Text': navLink.textContent.trim(),
            'Link URL': navLink.href
        }, true);
    });

    document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form || form.tagName !== 'FORM') return;

        var wrapper = form.closest('[data-tracking-event]');
        if (!wrapper) return;

        var trackingEvent = wrapper.getAttribute('data-tracking-event');
        fireTrackingEvent(trackingEvent, {
            content_name: 'Form submission',
            content_category: getButtonLocation(form)
        });
    });
}

function init() {
    if (isActive) {
        mixpanel.init(TOKEN, {
            ignore_dnt: true,
            api_host: PROXY_HOST,
            cross_subdomain_cookie: true,
            secure_cookie: true,
            track_pageview: "url-with-path"
        });
        mixpanel.register({ 'Source': 'website' });
    }

    // Expose for external use (identity linking from app)
    window.AskAstroAnalytics = {
        track: function (event, properties, isPageChange) {
            mixpanelTrack(event, properties || {}, isPageChange);
        },
        identify: function (userId) {
            if (isActive && userId) {
                mixpanel.identify(userId);
            }
        }
    };

    initEventListeners();
}

init();
